import { connect } from 'react-redux'
import New from './new'
import { create, fetchContract, lookup, resetFlags } from '../../actions'


const mapStateToProps = ({ settings, requestVehicleRelocations }) => ({
  fleetIds: settings.fleet.selected,
  relatedContract: requestVehicleRelocations.related,
  fetchContractStatus: requestVehicleRelocations.flags?.fetchContract || 'none',
  saveStatus: requestVehicleRelocations.flags?.create || 'none',
  errorMessage: requestVehicleRelocations.errorMessage,
  userRoles: settings.roles,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchContract: (agreementNo, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetchContract(null, {
      resourceId: agreementNo,
      queryParams: { FleetId }
    }))
  },
  onSave: (payload) => {
    dispatch(create(payload))
  },
  onLookup: (lookupPath, searchKey, customFleetId) => {
    dispatch(lookup(null, {
      resourceId: lookupPath,
      queryParams: { FleetId: customFleetId, Search: searchKey }
    }))
  },
  onReset: () => {
    dispatch(resetFlags())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(New)
